import { render, staticRenderFns } from "./setAddress.vue?vue&type=template&id=75291491&scoped=true&"
import script from "./setAddress.vue?vue&type=script&lang=js&"
export * from "./setAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75291491",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75291491')) {
      api.createRecord('75291491', component.options)
    } else {
      api.reload('75291491', component.options)
    }
    module.hot.accept("./setAddress.vue?vue&type=template&id=75291491&scoped=true&", function () {
      api.rerender('75291491', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setAddress.vue"
export default component.exports